export default {
  filter: '',
  loaded_init: false,
  permissions: []
}
